'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
Entry.BoxModel = /*#__PURE__*/(0, _createClass2["default"])(function BoxModel() {
  (0, _classCallCheck2["default"])(this, BoxModel);
  this.schema = {
    id: 0,
    type: Entry.STATIC.BOX_MODEL,
    x: 0,
    y: 0,
    width: 0,
    height: 0
  };
  Entry.Model(this);
});